export default function FooterSection() {
  return (
    <footer className="bg-[#30507F0F] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left - Logos */}
          <div className="w-full md:w-1/3 flex items-center justify-center md:justify-start mb-6 md:mb-0">
          <div className="flex items-end space-x-6">
            <img
              src="./logo.png"
              alt="ConversationAlly Logo"
              className="h-28 object-contain"   // bigger height
            />
            <img
              src="./Sigmmaza-logo.png"
              alt="Sigma Mozak Logo"
              className="h-14 object-contain"   // normal size
            />
          </div>
        </div>

          {/* Center - Text */}
          <div className="w-full md:w-1/3 flex flex-col items-center justify-center text-center px-4">
            <p className="text-sm text-gray-500 mb-2">
              ConversationAlly is a proprietary and patented product from SigmaMozak
            </p>
            <p className="text-sm text-gray-500">
              © 2026 SigmaMozak Solutions. All Rights Reserved.
            </p>
          </div>

          {/* Right - Address */}
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-end justify-center text-sm text-gray-500">
            <p className="text-center md:text-right">Corporate Office:</p>
            <p className="text-center md:text-right">Manjeera Diamond Towers, Diamond Heights,</p>
            <p className="text-center md:text-right">Nallagandla, Hyderabad, Telangana 500046</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
